import React from 'react';

import { useIntl } from 'react-intl';

import { ModalTitle, NewAddressModalHeading } from './styled';

export const DeliveryAddressFormHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <NewAddressModalHeading testID="modal-heading">
      <ModalTitle>{formatMessage({ id: 'enterYourDeliveryAddress' })}</ModalTitle>
    </NewAddressModalHeading>
  );
};
